export const templateGetters = {
  templates: (state) => state.templates,
  selectedBookingTemplate: (state) => state.selectedBookingTemplate,
  templateDetails: (state) => state.templateDetails,
};